import { Link } from 'react-router-dom';
import { categoryList } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            海量影视分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            涵盖电影、电视剧、综艺、动漫、纪录片等多种类型，满足你的所有观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {categoryList.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-xl p-4 md:p-6 flex flex-col items-center text-center transition-all duration-300 hover:bg-primary-100/60 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-200/60 transition-colors duration-300 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-800 text-sm md:text-base mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400">
                {cat.count.toLocaleString()}部
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}